import React, { useState, useMemo, useEffect } from 'react';
import { Box } from '@material-ui/core';
import styled from 'styled-components';
import AutoCompleteInput from '../../../../../../components/AutoCompleteInput';
import { Colors } from '../../../../../../constants';
import { useDebounceEffect } from '../../../../../../utils/hooks/useDebounceEffect';

const TitleStyle = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: ${Colors.TEXT_SECONDARY_BLACK};
`;

const Export = ({
  isExportDisabled = false,
  onExportPayloadChange,
  materialIds = [],
  materialIdsLoading = false,
  materialIdsHasMore = false,
  onMaterialIdsLoadMore,
  onMaterialIdsSearch,
  materialNames = [],
  materialNamesLoading = false,
  materialNamesHasMore = false,
  onMaterialNamesLoadMore,
  onMaterialNamesSearch,
}) => {
  const [productCodeList, setProductCodeList] = useState([]);
  const [productNameList, setProductNameList] = useState([]);

  const [codeSearchTerm, setCodeSearchTerm] = useState('');
  const [nameSearchTerm, setNameSearchTerm] = useState('');

  const handleCodeInputChange = (event, newInputValue) => {
    setCodeSearchTerm(newInputValue);
  };

  useDebounceEffect(
    () => {
      if (onMaterialIdsSearch) {
        onMaterialIdsSearch(codeSearchTerm);
      }
    },
    400,
    [codeSearchTerm],
  );

  const handleNameInputChange = (event, newInputValue) => {
    setNameSearchTerm(newInputValue);
  };

  useDebounceEffect(
    () => {
      if (onMaterialNamesSearch) {
        onMaterialNamesSearch(nameSearchTerm);
      }
    },
    400,
    [nameSearchTerm],
  );

  const materialFilters = useMemo(
    () => ({
      ...(productCodeList.length > 0
        ? { productCodes: productCodeList.map((item) => item.code) }
        : {}),
      ...(productNameList.length > 0
        ? { productNames: productNameList.map((item) => item.name) }
        : {}),
    }),
    [productCodeList, productNameList],
  );

  useEffect(() => {
    if (onExportPayloadChange) {
      onExportPayloadChange({ materialFilters });
    }
  }, [onExportPayloadChange, materialFilters]);

  return (
    <Box style={{ padding: "20px 0px", width: "720px" }}>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "16px 24px",
          gap: "16px",
        }}
      >
        <TitleStyle>Materiais</TitleStyle>
        <AutoCompleteInput
          options={materialIds}
          value={productCodeList}
          onChange={(e, newValue) => setProductCodeList(newValue)}
          onInputChange={handleCodeInputChange}
          onLoadMore={onMaterialIdsLoadMore}
          hasMore={materialIdsHasMore}
          loading={materialIdsLoading}
          getOptionLabel={(option) => option?.code ?? ''}
          getOptionSelected={(option, val) => option?.id === val?.id}
          placeholder="Código do produto"
        />
        <AutoCompleteInput
          options={materialNames}
          value={productNameList}
          onChange={(e, newValue) => setProductNameList(newValue)}
          onInputChange={handleNameInputChange}
          onLoadMore={onMaterialNamesLoadMore}
          hasMore={materialNamesHasMore}
          loading={materialNamesLoading}
          getOptionLabel={(option) => option?.name ?? ''}
          getOptionSelected={(option, val) => option?.id === val?.id}
          placeholder="Nome do produto"
        />
      </Box>
    </Box>
  );
};

export default Export;
